import { PROCEED_TO_AUTH, PROCEED_TO_AUTH_ERROR_DATA, PROCEED_TO_AUTH_HIDE_ERROR_DATA, PROCEED_TO_AUTH_START_LOADER, PROCEED_TO_AUTH_STOP_LOADER, } from "../interface/IProceedToAuth";
const initState = {
    data: {
        cpld: {
            dp: "",
            req: "",
            reqId: "",
            url: "",
            vsn: "",
        },
        sts: "",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const proceedToAuth = (state = initState, action) => {
    switch (action.type) {
        case PROCEED_TO_AUTH: {
            return Object.assign(Object.assign({}, state), { data: action.payload.proceedToAuth });
        }
        case PROCEED_TO_AUTH_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PROCEED_TO_AUTH_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case PROCEED_TO_AUTH_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case PROCEED_TO_AUTH_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default proceedToAuth;
